import { makeStyles } from '@material-ui/core/styles';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontSize } from '../../../../styles/themes/vad/font';

const isOnlyFeaturedTagScenario = (isFeatured, logoImageUrl, isFutureDate) => {
  return (isFeatured && isFeatured.value) && !(logoImageUrl && logoImageUrl.value) && !isFutureDate;
}

const useStyles = makeStyles(theme => ({
  root: {

    ...theme.mixins.paddingLeft('5.8%'),
    backgroundColor: '#00D8CC',
    color: theme.mixins.White(),
    position: 'relative',
    width: '100%',
    ...theme.mixins.paddingRight(theme.spacing(3)),
    zIndex: 2,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
      maxWidth: '50%',
      minWidth: pxToRem(410),
      ...theme.mixins.paddingRight(theme.spacing(7)),
    },

    '&.configurableTimer': {
      marginTop: pxToRem(-42),
      marginBottom: pxToRem(-16),
      color: ({ textColor }) => textColor || theme.palette.primary.main,
      [theme.breakpoints.down('md')]: {
        marginTop: pxToRem(-48.4),
        width: '100%',

        '& .contentWrapper': {
          justifyContent: 'flex-start',
        },
      },
      '& .renderer': {
        [theme.breakpoints.up('lg')]: {
          ...theme.mixins.paddingRight(pxToRem(12)),
        },
        '&:last-child': {
          [theme.breakpoints.up('lg')]: {
            ...theme.mixins.paddingRight(pxToRem(4)),
          },
        },
      },
      '& .MuiTypography-h5': {
        fontFamily: theme.typography.fontFamily.primaryRegular,
        fontSize: fontSize.s16Rem,
        lineHeight: fontSize.s19Rem,
        [theme.breakpoints.up('lg')]: {
          fontSize: fontSize.s36Rem,
          lineHeight: fontSize.s44Rem,
        },
      },
      '& .MuiTypography-body2Bold': {
        [theme.breakpoints.down('md')]: {
          fontFamily: theme.typography.fontFamily.primaryRegular,
          fontSize: fontSize.s12Rem,
          lineHeight: fontSize.s18Rem,
        },
      },
    },

    contentWrapper: {
      width: '100%',
    },

    '& .eventLogo': {
      position: 'relative',
      backgroundColor: theme.mixins.White(),
      ...theme.mixins.marginRight(theme.spacing(2)),
      '& img': {
        position: 'relative',
        top: pxToRem(-32),
        zIndex: 1,
        maxWidth: '120px',
        [theme.breakpoints.up('lg')]: {
          maxWidth: '220px',
          top: pxToRem(-22),
        },
      },
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.marginRight(theme.spacing(3)),
      },
    },

    '& .timer': {
      paddingTop: pxToRem(24), //# TODO confirm with design
      paddingBottom: pxToRem(24),
      [theme.breakpoints.up('lg')]: {
        paddingTop: pxToRem(36),
        paddingBottom: pxToRem(36),
      },

      [theme.breakpoints.down('md')]: {
        color: '#000',
      }
    },
    background: ({ isFeatured, logoImageUrl, isFutureDate }) => isOnlyFeaturedTagScenario(isFeatured, logoImageUrl, isFutureDate) && 'transparent',
  },
  tag: {
    zIndex: 2,
    position: 'absolute',
    top: pxToRem(-20),
    ...theme.mixins.left('5.8%'),
    borderRadius: borderRadius.b3,
    background: '#009086',
    color: '#FFFFFF',
    padding: '4px 8px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('md')]: {
      maxWidth: '220px',
      top: pxToRem(-12),
      fontSize: pxToRem(12),
      lineHeight: pxToRem(16),
    },
    '&.sty2': {
      ...theme.mixins.left('calc(5.8% + ' + pxToRem(80) + ' + 12px)'),

      '&.noFeatured': {
        ...theme.mixins.left('5.8%'),
      },
    },
    [theme.breakpoints.up('lg')]: {
      top: pxToRem(-16),
      ...theme.mixins.left(pxToRem(74)),
    },

    '&.eventTimerTag.sty2': {
      '[dir="rtl"] &': {
        ...theme.mixins.left('calc(5.8% + ' + pxToRem(88) + ' + 12px)'),

        '&.noFeatured': {
          ...theme.mixins.left('5.8%'),
        },
      },
    }
  },
  renderer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...theme.mixins.paddingRight(theme.spacing(1)),
    [theme.breakpoints.down('md')]: {
      ...theme.mixins.paddingRight(pxToRem(13)),
    },

    '& .time-value': {
      fontSize: pxToRem(36),
      lineHeight: pxToRem(40),
    },

    '& .time-unit': {
      fontSize: pxToRem(16),
    },
  },
  dateItem: {
    display: 'flex',
    textTransform: 'uppercase',
    ...theme.mixins.paddingRight(theme.spacing(1)),
    [theme.breakpoints.down('md')]: {
      ...theme.mixins.paddingRight(pxToRem(12)),
    },
    '&:last-child': {
      minWidth: pxToRem(80),
      '& .renderer': {
        alignItems: 'flex-start'
      }
    },
    '& .time-seperator': {
      fontSize: pxToRem(32),
      lineHeight: pxToRem(40),
    },
  },
}));

export default useStyles;
